export default __webpack_public_path__ + "svg/map/Ciudades-icex-2026.svg?a4ee89e4";